import { Suspense, useEffect } from 'react';
import { Routes, Route } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';

import { Header, Menu, LoaderCube } from '@greenkub-fronts/shared/ui';
import {
  getCurrentProject,
  initCustomerArea,
} from '@greenkub-fronts/domain/customer-area';
import { AppDispatch, RootState } from '@greenkub-fronts/shared/interface';

import CustomerMenuContentFeature from './feature/commons-feature/customer-menu-content-feature/customer-menu-content-feature';
import CustomerFooterFeature from './feature/commons-feature/customer-footer-feature/customer-footer-feature';
import { ROUTER_CUSTOMER_AREA } from './router/router';

export function AreaCustomerPage() {
  const dispatch = useDispatch<AppDispatch>();

  const { user } = useSelector((state: RootState) => state.auth);
  const { currentTheme } = useSelector((state: RootState) => state.ui);

  useEffect(() => {
    dispatch(initCustomerArea({}));
  }, [user, dispatch]);

  const currentProject = useSelector((state: RootState) =>
    getCurrentProject(state)
  );

  if (!currentProject) return <></>;

  return (
    <Suspense fallback={<LoaderCube isLoading={true} />}>
      <Header isCrm={false} currentTheme={currentTheme} />

      <Menu>
        <CustomerMenuContentFeature />
      </Menu>

      <main className="Home-container">
        <Routes>
          {ROUTER_CUSTOMER_AREA.map((route) => (
            <Route
              key={route.path}
              path={route.path}
              element={
                <Suspense fallback={<LoaderCube isLoading={true} />}>
                  {route.component}
                </Suspense>
              }
            />
          ))}
        </Routes>
      </main>

      <CustomerFooterFeature />
    </Suspense>
  );
}

export default AreaCustomerPage;
